var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChangeWorkspace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_922_3449)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 13.3125C9 13.0018 9.25184 12.75 9.5625 12.75H13.3125C13.6232 12.75 13.875 13.0018 13.875 13.3125C13.875 13.6232 13.6232 13.875 13.3125 13.875H9.5625C9.25184 13.875 9 13.6232 9 13.3125Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1648 11.4148C12.3844 11.1951 12.7406 11.1951 12.9602 11.4148L14.4602 12.9148C14.6799 13.1344 14.6799 13.4906 14.4602 13.7102L12.9602 15.2102C12.7406 15.4299 12.3844 15.4299 12.1648 15.2102C11.9451 14.9906 11.9451 14.6344 12.1648 14.4148L13.267 13.3125L12.1648 12.2102C11.9451 11.9906 11.9451 11.6344 12.1648 11.4148Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.46025 6.96025C5.07663 7.34387 4.875 8.05848 4.875 9.5625V14.8125C4.875 16.3165 5.07663 17.0311 5.46025 17.4148C5.84387 17.7984 6.55848 18 8.0625 18H15.5625C17.0665 18 17.7811 17.7984 18.1648 17.4148C18.5484 17.0311 18.75 16.3165 18.75 14.8125V12.5625C18.75 11.0585 18.5484 10.3439 18.1648 9.96025C17.7811 9.57663 17.0665 9.375 15.5625 9.375H13.3125C12.8867 9.375 12.5413 9.31228 12.2472 9.13453C11.9846 8.97583 11.8136 8.74979 11.6882 8.5839C11.6802 8.57329 11.6723 8.56294 11.6647 8.55286L11.6625 8.55001L11.6625 8.55L10.5375 7.05C10.3103 6.7471 10.2046 6.61816 10.0594 6.53093C9.92752 6.45171 9.7013 6.375 9.1875 6.375H8.0625C6.55848 6.375 5.84387 6.57663 5.46025 6.96025ZM4.66475 6.16475C5.40613 5.42337 6.56652 5.25 8.0625 5.25H9.1875C9.7987 5.25 10.2587 5.33829 10.6387 5.56657C10.9904 5.77785 11.218 6.08186 11.4128 6.34203C11.4211 6.35311 11.4293 6.3641 11.4375 6.375L12.5615 7.87362C12.7181 8.07963 12.7673 8.1344 12.8291 8.17172C12.8762 8.20022 12.9883 8.25 13.3125 8.25H15.5625C17.0585 8.25 18.2189 8.42337 18.9602 9.16475C19.7016 9.90613 19.875 11.0665 19.875 12.5625V14.8125C19.875 16.3085 19.7016 17.4689 18.9602 18.2102C18.2189 18.9516 17.0585 19.125 15.5625 19.125H8.0625C6.56652 19.125 5.40613 18.9516 4.66475 18.2102C3.92337 17.4689 3.75 16.3085 3.75 14.8125V9.5625C3.75 8.06652 3.92337 6.90613 4.66475 6.16475Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_922_3449"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeWorkspace);
export default __webpack_public_path__ + "static/media/changeWorkspace.1ff3771c.svg";
export { ForwardRef as ReactComponent };